import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';

const ZapiInstancesView = () => import('./ZapiInstancesView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/zapi-instances'),
    name: 'zapi_instances_dashboard',
    meta: {
      featureFlag: FEATURE_FLAGS.ZAPI_INSTANCES,
      permissions: ['administrator'],
    },
    component: ZapiInstancesView,
  },
];
